import { Styles } from 'models';

export const getVariantColor = (str: Styles.ColorVariant = 'dark'): string => Styles.VARIANT_MAPPING[str] || Styles.VARIANT_MAPPING['dark'];
export const getMarkerColor = (index: number = 0): string => Styles.MARKER_COLOR_LIST.at(index % Styles.MARKER_COLOR_LIST.length);
export const getRangeHandleColor = (index: number = 0, array?: string[]): string => {
  array = array || Styles.RANGE_HANDLE_COLOR_LIST;
  return array.at((((index % array.length) + Math.floor(index / array.length)) % array.length) % array.length);
};
